import { render, staticRenderFns } from "./NominateReviewersExpired.vue?vue&type=template&id=0b88e049&scoped=true&"
import script from "./NominateReviewersExpired.vue?vue&type=script&lang=js&"
export * from "./NominateReviewersExpired.vue?vue&type=script&lang=js&"
import style0 from "./NominateReviewersExpired.vue?vue&type=style&index=0&id=0b88e049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88e049",
  null
  
)

export default component.exports